import { createPaginatedFetcher } from '@/@core/libs/fetch/usePaginatedFetcher'
import Vue from 'vue'

export default function useProductManagements(vm) {
  const state = Vue.observable({
    fetcher: undefined,
  })

  const mapProductInWarehouse = productInWarehouse => {
    try {
      const mappedData = productInWarehouse.map(item => {
        const {
          packings,
          addon_cost,
          addon_minimum,
          product_weight_pbv,
          product_name,
          product_id,
          is_bundling,
          variants,
          fulfillment_cost = [],
          is_product_bonus,
          storage_type,
        } = item

        const getVariants = () => {
          if (is_bundling) {
            return item.product_bundle.map(product => ({
              ...product,
              bundling_variants: product.variants.map(variant => ({
                ...variant,
                product_id: product.product_id,
                qty: product.qty,
                available: 0,
                usedStock: 0,
                is_product_bonus: product.is_product_bonus,
              })),
            }))
          } if (variants.length > 0) {
            return variants.map(variant => ({
              ...variant,
              product_id,
              qty: 1,
              available: 0,
              usedStock: 0,
              is_product_bonus: variant.is_product_bonus,
            }))
          }
          return [{
            id: product_id,
            name: product_name,
            stock: item.stock,
            product_id,
            qty: 1,
            available: 0,
            usedStock: 0,
            label: product_name.concat(' : -'),
            is_product_bonus,
            storage_type,
          }]
        }

        return {
          label: product_name,
          value: product_id,
          variants: getVariants(),
          packings,
          addon_cost,
          addon_minimum,
          product_weight_pbv,
          is_variant: variants.length > 0,
          is_bundling,
          is_product_bonus,
          fulfillment_cost,
          storage_type,
        }
      })

      return mappedData
    } catch {
      vm.$toast_error({ message: 'Gagal mapping data produk, silakan coba lagi' })
      return null
    }
  }

  const initializeFetcherProductInWarehouse = () => {
    const fnFetch = ({
      offset, limit, search, warehouseId,
    }) => vm.$http_new.get(`/komship/api/v1/product-warehouses/partners/${vm.userData.partner_detail.id}/warehouses/${warehouseId}`, {
      params: {
        page: offset,
        limit,
        keyword: search,
      },
    }).then(res => {
      const { data } = res.data
      if (!data || data.length === 0) {
        if (offset === 0 && !search) {
          throw new Error('No data found')
        }
        return {
          data: [],
        }
      }
      const mappedData = mapProductInWarehouse(data)
      return {
        data: mappedData || [],
      }
    }).catch(error => {
      console.error(error.message)
      if (error.message === 'No data found') {
        vm.$toast_error({
          message: 'Anda tidak memiliki produk yang disimpan di gudang tersebut, silahkan tambahkan produk terlebih dahulu',
        })
        return {
          data: [],
        }
      }
      vm.$toast_error({
        message: 'Gagal mengambil data produk gudang, silahkan coba lagi',
      })
      return {
        data: [],
      }
    })

    state.fetcher = createPaginatedFetcher(fnFetch, 0, 50)
  }

  const getProductInWarehouse = async warehouseId => {
    try {
      const { data } = await this.$http_new.get(`/komship/api/v1/product-warehouses/partners/${this.userData.partner_detail.id}/warehouses/${warehouseId}`, {
        params: {
          keyword: '',
          limit: 100,
          offset: 0,
        },
      })
      return mapProductInWarehouse(data.data)
    } catch {
      return null
    }
  }

  return {
    state,
    initializeFetcherProductInWarehouse,
    getProductInWarehouse,
    mapProductInWarehouse,
  }
}
